import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { DeploymentUtils } from 'libs.react_internal';
import { EnvironmentsContext } from '../../contexts/environments';
import { TimeTravelLaneContext } from '../../contexts/time_travel_lane';
export const useCurrentEnvironment = (overrideStudyId) => {
    const { studyId } = useParams();
    const studyIdToUse = overrideStudyId || studyId;
    const { environments } = useContext(EnvironmentsContext);
    const { selectedLane, setSelectedLane, laneCount } = useContext(TimeTravelLaneContext);
    const baseEnvironment = useMemo(() => environments?.find((env) => +env.id === +studyIdToUse), [environments, studyIdToUse]);
    // Rewrite cortexURL to the selected lane host so Axon/Cortex calls and settime share one clock.
    const environment = useMemo(() => {
        if (!baseEnvironment) {
            return undefined;
        }
        if (laneCount <= 1 || selectedLane <= 1) {
            return baseEnvironment;
        }
        return {
            ...baseEnvironment,
            cortexURL: DeploymentUtils.getLaneCortexUrl(baseEnvironment.cortexURL, selectedLane),
        };
    }, [baseEnvironment, laneCount, selectedLane]);
    if (window.currentEnvironment?.id !== environment?.id ||
        window.currentEnvironment?.cortexURL !== environment?.cortexURL) {
        window.currentEnvironment = environment;
    }
    return {
        environment,
        /** Unrewritten cortex URL from MOM (no `-lN` suffix). Use for hostname parsing / get_study_url. */
        baseCortexURL: baseEnvironment?.cortexURL,
        studyId: studyIdToUse,
        selectedLane,
        setSelectedLane,
        laneCount,
    };
};
